import {
  ApiResponse,
  PoolDiscountGrouped,
  CreateDiscount,
  TokenData,
  PoolDiscount,
  OtpResponse,
  CreateDiscountLimits,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class PoolDiscountService extends ApiService {
  public async loadPoolDiscount() {
    const url = `${this.apiDomain}/api/discount/pool`;

    const resposne = await http.get<ApiResponse<PoolDiscountGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDiscount(data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/pool`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async updateDiscount(id: string, data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/pool/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async getPoolDiscount(id: string) {
    const url = `${this.apiDomain}/api/discount/pool/${id}`;

    const resposne = await http.get<ApiResponse<PoolDiscount>>(url, this.store);
    return resposne?.data?.data;
  }

  public async updatePoolDiscountLimits(
    data?: CreateDiscountLimits,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/pool/${id}/limits`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async cloneDiscount(data: CreateDiscount, id?: string) {
    const url = `${this.apiDomain}/api/discount/pool/${id}/clone`;

    const response = await http.post<ApiResponse<PoolDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data?.data;
  }
  public async deleteDiscount(id?: string) {
    const url = `${this.apiDomain}/api/discount/pool/${id}`;
    const response = await http.remove<ApiResponse<PoolDiscount>>(
      url,
      this.store
    );
    return response?.data?.data;
  }
}
